import React from "react";
import { PortfolioCard } from "components";
import { PORTFOLIO_IMAGES } from "data";

const PortfolioSection = () => {
  return (
    <div
      className="w-full py-28 px-4 text-white flex justify-center"
      id="portfolio"
    >
      <div>
        <h1 className="text-center text-4xl font-semibold mt-10 mb-10">
          Our Work
        </h1>
        <div className="max-w-[1240px] mx-auto grid sm: grid-cols-1	md:grid-cols-2 gap-8">
          {PORTFOLIO_IMAGES.map((image) => (
            <PortfolioCard key={image.id} image={image} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PortfolioSection;
